<div
  class="d-flex flex-column align-items-center h-100 w-100 justify-content-center px-4 py-4 modal-main user-profile-access-main"
>
  <div class="header mt-1 mb-4 w-100">
    <div class="d-flex justify-content-between">
      <span class="col-2 d-flex flex-row align-items-center">
        <img
          src="/assets/svg/ico-chevron-back-outline.svg"
          alt="back button"
          class="pointer-cursor"
          (click)="navigateBack()"
        />
      </span>
      <div class="d-flex flex-column justify-content-center col-8">
        <span class="col-5 user-title m-auto text-center">
          <app-with-tooltip [showHelpCursor]="true">
            {{ this.formInstance?.name?.value }}
          </app-with-tooltip></span
        >
        <span class="modal-title m-auto">
          {{ 'ACCESS' | translate }}
        </span>
      </div>
      <span
        class="col-2 d-flex flex-row align-items-center justify-content-end pr-2"
      >
        <ng-container *ngIf="userAccessOperations === CONSTANTS.EDIT">
          <img
            src="assets/svg/ico-lock-access-settings.svg"
            class="pr-2 pointer-cursor"
            (click)="onSettings()"
          />
        </ng-container>
        <img
          src="/assets/svg/ico-hamburger-close.svg"
          class="cross-button pointer-cursor offset-1"
          (click)="closeDialog()"
        />
      </span>
    </div>
  </div>

  <ng-container *ngIf="userAccessOperations === CONSTANTS.EDIT">
    <div class="w-100">
      <app-update-user-access
        [commonAccessControl]="commonAccessControl"
        [siteTimeZone]="siteTimeZone"
        [userAccess]="userAccess"
        (editAccessEmmiter)="editAccessEmitter($event)"
      ></app-update-user-access>
    </div>
  </ng-container>

  <ng-container *ngIf="userAccessOperations === CONSTANTS.REMOVE">
    <div class="w-100">
      <app-remove-user-access
        [commonAccessControl]="commonAccessControl"
        [userAccess]="userAccess"
        [siteTimeZone]="siteTimeZone"
        [accessIds]="accessIds"
        (removeAccessEmitter)="removeAccessList($event)"
      >
      </app-remove-user-access>
    </div>
  </ng-container>

  <ng-container *ngIf="userAccessOperations === CONSTANTS.EDIT">
    <div class="row w-100">
      <div class="col-12 my-1">
        <button
          type="button"
          class="btn btn-danger px-3 w-100 btn-submit"
          (click)="addNewAccess.emit()"
          [disabled]="assigningAccess"
        >
          {{ 'ADD_NEW_ACCESS' | translate }}
        </button>
      </div>
    </div>
  </ng-container>

  <ng-container *ngIf="userAccessOperations === CONSTANTS.REMOVE">
    <div class="row w-100">
      <div class="col-12 my-1">
        <button
          class="btn btn-danger px-3 w-100 btn-submit"
          (click)="removeAccessHandler()"
          [disabled]="accessIds.length === 0"
        >
          {{ 'DELETE_TEXT' | translate }}
        </button>
      </div>
    </div>
  </ng-container>
</div>
